import CalculatorsController from '../../src/javascripts/cvm';
import PmbPracticeSolution from '../../src/javascripts/models/pmb/practice_solution';
import '../../src/javascripts/helpers/application/self_service_pdf_launcher';
import '../../src/javascripts/helpers/rectangle/amount_per_statement_calculator';
import '../../src/stylesheets/pmb/pmb_shared.scss';

(function() {
  $(() => CalculatorsController.run(new PmbPracticeSolution()));
}).call(this);

